/* AbstractCommand superclass
 * methods:
 * - execute: has no fields to be passed. All parameters to be get into account is to set by means of an implementation constructor
 * - undo: cancel or change system status back if it is possible
 */

define([], function()
{
    function AbstractCommand() {}
    var c = AbstractCommand;
    var p = c.prototype;

    p.execute = function() {};
    p.undo = function()	{};
    return AbstractCommand;
});



// WEBPACK FOOTER //
// ./js/rrjs/base/commands/AbstractCommand.js